// extracted by mini-css-extract-plugin
module.exports = {"selector-strip":"opco-selectors_selector-strip__x9Lkh"};